export type Localized = { en: string; ru: string }
export type Locale = keyof Localized

export const site = {
  name: 'mkultra69',
  bio: 'writing shit, smoking shit, living shitlife. Fullstack dev, DevVpops sex engineer',
  labels: {
    about: { en: 'about', ru: 'обо мне' }, portfolio: { en: 'portfolio', ru: 'портфолио' },
    machines: { en: 'machines', ru: 'машины' }, links: { en: 'links', ru: 'ссылки' },
    language: { en: 'RUS', ru: 'ENG' }, terminal: { en: 'Terminal commands', ru: 'Команды терминала' },
    loading: { en: 'Loading projects…', ru: 'Загрузка проектов…' }, unavailable: { en: 'Projects are currently unavailable.', ru: 'Проекты временно недоступны.' },
  },
  links: [
    { label: 'Telegram info', url: 'https://t.me/oreshki_info' }, { label: 'Telegram', url: 'https://t.me/mkultra6969' },
    { label: 'GitHub', url: 'https://github.com/MKultra6969' }, { label: 'PRSDRTY KLIRNET', url: 'https://prsdrnet.mk69.dev/' },
    { label: 'KLIRNET bot', url: 'https://t.me/prsdrtyKLIRNET_bot' }, { label: 'KLIRNET channel', url: 'https://t.me/prsdrty_KLIRNET' },
    { label: 'NEKONODE', url: 'https://nekonode.ltd/' }, { label: 'Catsgram', url: 'https://catsgram.mk69.dev/' },
    { label: 'Catsgram bot', url: 'https://t.me/Catsgram_robot' },
  ],
  /**
   * The current job. The role itself is under NDA, so every surface that shows
   * it (`work`, the boot banner, the GUI) says where, never what.
   */
  work: {
    company: 'NEKONODE LTD',
    url: 'https://nekonode.ltd/',
    /** Slug of the matching portfolio card. */
    project: 'nekonode',
    since: 2026,
    role: { en: 'developing and launching the hosting', ru: 'разработка и запуск хостинга' },
    about: {
      en: 'hosting and network infrastructure on its own ASN, AS219441',
      ru: 'хостинг и сетевая инфраструктура на собственной ASN, AS219441',
    },
    nda: { en: 'what exactly I do there is under NDA', ru: 'чем именно занимаюсь — под NDA' },
  },
} as const satisfies {
  name: string
  bio: string
  labels: Record<string, Localized>
  links: readonly { label: string; url: string }[]
  work: { company: string; url: string; project: string; since: number; role: Localized; about: Localized; nda: Localized }
}
